<template>
  <div class="row">
    <div class="col-12 col-lg-6">
      <SuccessAlert :message="successMessage()"/>
    </div>
    <div class="col-12 col-lg-6">
      <div v-if="isCardPayment" class="alert alert-success" role="alert">
        <h4 class="alert-heading">Pay securely with Payfast</h4>
        <p>Amount Due: R{{ order.order_total }}<br>
          {{ order.delivery_method === 'D' ? 'Delivery: Free' : 'Collection' }}</p>
        <form :action="order.payfast.url" method="post">
          <input v-for="(value, name) in order.payfast.fields"
                 :key="name" :name="name" :value="value" type="hidden">
          <button type="submit" class="btn btn-success">Pay Now with Payfast</button>
        </form>
        <hr>
        <p class="mb-0">You will be redirected to Payfast to complete your payment.</p>
      </div>

    </div>
  </div>
</template>

<script>
import SuccessAlert from "../shared/alerts/SuccessAlert.vue";

export default {
  name: 'order-payment',
  props: {
    paymentMethod: String,
    order: Object,
  },
  data() {
    return {
      isCardPayment: false,
    }
  },
  methods: {
    successMessage() {
      return 'Thank you ' +  this.order.name + '. Your order has been placed';
    },
    whichPaymentMethod() {
      this.isCardPayment = this.order.payment_method === 'CARD';
    },
  },
  mounted() {
    this.whichPaymentMethod();
  },
  components: {
    SuccessAlert,
  }
}
</script>
